import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';

interface UpdateFileParams {
  id: string;
  display_name?: string;
  folder_id?: string | null;
  category_ids: string[];
}

export function useUpdateFileMutation() {
  const queryClient = useQueryClient();

  const { mutateAsync: updateFileMutation, isLoading } = useMutation(
    ({ id, ...data }: UpdateFileParams) => API_HANDLERS.FILES.UPDATE(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['files']);
        queryClient.invalidateQueries(['folders']);
      },
    },
  );

  return { updateFileMutation, isLoading };
}
